import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { skipErrorAlert } from '../shared/api/api-error';

import { AlertService } from './alert.service';

@Injectable()
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

  constructor(
    private http: HttpClient,
    private alertService: AlertService
  ) { }

  /**
   * Checks in every set frequency the version of frontend application
   * @param url
   * @param {number} frequency - in milliseconds, defaults to 2 minutes
   */
  public initVersionCheck(url, frequency = 1000 * 60 * 10) {
    setInterval(() => {
      this.checkVersion(url);
    }, frequency);
  }

  /**
   * Will do the call and check if the hash has changed or not
   * @param url
   */
  private checkVersion(url) {
    // timestamp these requests to invalidate caches
    // -----> add branching logic depending on if we are ssl.
    // Opted out of the error alert: this runs on a ten-minute timer, so a version.json that is
    // briefly unreachable would otherwise toast on every tick.
    this.http.get(url + '?t=' + new Date().getTime(), { context: skipErrorAlert() })
      .pipe(first())
      .subscribe(
        (response: any) => {
          const hash = response.hash;
          const comments = response.comments;
          const hashChanged = this.hasHashChanged(this.currentHash, hash);
          console.log('Checked version hash:', hash);
          console.log('Checked version comments:', comments);
          console.log('Checked version hashChanged:', hashChanged);

          // If new version, do something
          if (hashChanged) {
            this.alertService.newVersion(comments);
          }
          // store the new hash so we wouldn't trigger versionChange again
          // only necessary in case you did not force refresh
          this.currentHash = hash;
        },
        (err) => {
          // TODO - Better error handling here?
          console.error(err, 'Could not get version');
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentHash
   * @param newHash
   * @returns {boolean}
   */
  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }
}
